import { EXTENDED_PARAMETERS_SERVICE_NAME, ExtendedParametersServiceProvider } from './extended-parameters.service'

export const EXTENDED_PARAMETERS_SERVICES_MODULE_NAME = 'simax.services.extended-aprameters'

const extendedParametersServicesModule = angular.module(EXTENDED_PARAMETERS_SERVICES_MODULE_NAME, [])

extendedParametersServicesModule.provider(EXTENDED_PARAMETERS_SERVICE_NAME, ExtendedParametersServiceProvider)
